import {
  Box,
  Center,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import DetailsPage_Component from "../../../Components/Recruiter/Details/DetailsPage_Component";
import Details_Jobrole from "../../../Components/Recruiter/Details/Details_Jobrole";
import Navbar from "../../../Components/Recruiter/Navbar/Navbar";
import * as api from "../../../services/api";
import back from "../../../Assets/back_icon.png";
import Applications_page from "../../../Components/Recruiter/Application_View/Applications_page";
import SentInvite_Page from "../../../Components/Recruiter/SentView/SentInvite_Page";

const Details_Page = ({
  student = false,
  postID,
  appliedData,
  inviteId,
  status,
  setAppliedData,
  setInvites,
  posts,
  setPostID,
  setSavedPosts,
  accepted,
  setPosts,
  setMobileView,
}) => {

  const location = useLocation();
  const locationEndpoint = location?.pathname?.split("/");
  // console.log(locationEndpoint[4]);

  // for mobile view

  const [applicationData, setApplicationData] = useState({});
  const [invitesData, setInvitesData] = useState({});

  const postIdMini = locationEndpoint[4];

  useEffect(() => {
    const getAllApplicationsForJob = async () => {
      if (postIdMini) {
        const applications = await api.getAllApplicationsForJob(postIdMini);

        setApplicationData(applications.data.data);
      }
    };

    const getAllInvitesForJobPost = async () => {
      if (postIdMini) {
        const invites = await api.getAllInvitesForJobPost(postIdMini);

        setInvitesData(invites.data.data);
      }
    };
    getAllApplicationsForJob();
    getAllInvitesForJobPost();
  }, [postIdMini]);

  // console.log(applicationData);

  return (
    <>
      {student ? null : <Navbar />}
      <Box
        borderBottom="1px solid #E4E4E4"
        mt={[8, 8, 16, 16]}
        style={{
          display: student ? "none" : "block",
        }}
      >
        <Flex
          align="center"
          gap={3}
          ml={[1, 1, 10, 10]}
          py={4}
          mt={[14, 14, 20, 20]}
        >
          <Link to="/hiring/recruiter/active">
            <Box cursor="pointer" mt={[-2, -2, 0, 0]}>
              <img src={back} alt="back" />
            </Box>
          </Link>
          <Heading
            fontSize={[20, 20, 24, 24]}
            fontFamily={"Epilogue"}
            fontWeight={600}
            color="#544D5E"
          >
            Job Post details
          </Heading>
        </Flex>
      </Box>
      {/* Destop View */}

      <Flex display={!student ? ["none", "none", "flex", "flex"] : "flex"}>
        <Details_Jobrole
          student={student}
          inviteId={inviteId}
          accepted={accepted}
          setAppliedData={setAppliedData}
          appliedData={appliedData}
          setPostID={setPostID}
          setSavedPosts={setSavedPosts}
          setPosts={setPosts}
          posts={posts}
          setInvites={setInvites}
          status={status}
          postID={postID?.length ? postID : locationEndpoint[4]}
          setMobileView={setMobileView}
        />
        {/* <DetailsPage_Component postId={locationEndpoint[4]} /> */}
        {!student ? (
          <DetailsPage_Component postId={locationEndpoint[4]} />
        ) : null}
      </Flex>

      {/* Mobile View */}
      {!student ? (
        <Tabs display={["block", "block", "none", "none"]}>
          <TabList justifyContent={"space-evenly"}>
            <Tab>Details</Tab>
            <Tab>Applications</Tab>
            <Tab>Invites</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Details_Jobrole
                student={student}
                appliedData={appliedData}
                postID={postID?.length ? postID : locationEndpoint[4]}
              />
              {/* {!student ? (
              <DetailsPage_Component postId={locationEndpoint[4]} />
            ) : null} */}
            </TabPanel>
            <TabPanel>
              <Applications_page applicationData={applicationData.data} />
            </TabPanel>
            <TabPanel>
              <SentInvite_Page data={invitesData.data} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : null}
    </>
  );
};
export default Details_Page;
